
const API_BASE_URL = "";

module.exports = {
    API_BASE_URL,
};